import { useState, useEffect, useRef } from 'react'
import { throttle } from 'throttle-debounce'

const useScroll = (setScrollTarget, delay=0) => {
  const [scrollRef, setScrollRef] = useState(undefined)
  const callbackRef = useRef(null)

  const addScrollEvent = () => {
    const threshold = 50;
    let lastScrollY = scrollRef?.scrollTop
    let ticking = false;
  
    const updateScrollDir = () => {
      const scrollY = scrollRef?.scrollTop
  
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollTarget(scrollY > lastScrollY ? true : false);
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    }
  
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    }

    scrollRef?.addEventListener("scroll", throttle(100, onScroll), { passive: true });
    callbackRef.current = onScroll
  }

  useEffect(() => {
    // NOTE: The delay helps us prevent the scroll position updates from triggering animations
    //       When the page loads between navigations. Especially with Virtuoso, it will change
    //       the scroll position when reloading the old state, but it offers no callbacks to
    //       tell you when the state is done being loaded. That means delaying the addition of
    //       the scroll trigger event handler is the best we can do.
    if (delay > 0) {
      setTimeout(addScrollEvent, delay)
    } else {
      addScrollEvent()
    }
    return () => scrollRef?.removeEventListener("scroll", callbackRef.current);
  }, [scrollRef]);

  return {
    setScrollRef,
    scrollRef,
  }
}

export default useScroll
